module.exports = __webpack_public_path__ + "img/BigGuns2.d4c2ce46.png";